export default String.raw`
{% assign product = product-presentation.Product -%}

{% if include == 'notify-about-availability' -%}
	{% assign title = translations.NotifyMeAboutAvailability -%}
	{% assign action = 'Product/NotifyAboutProductAvailability' -%}
	{% assign email = translations.Email -%}
	{% assign name = translations.CompanyName -%}
{% elseif include == 'ask-for-price' -%}
	{% assign title = translations.AskForPrice -%}
	{% assign action = 'Product/AskForPrice' -%}
	{% assign email = translations.Email -%}
{% elseif include == 'ask-about-product' -%}
	{% assign title = translations.AskAboutProduct -%}
	{% assign action = 'Contact/AskAboutProduct' -%}
	{% assign email = translations.Email -%}
	{% assign name = translations.CompanyName -%}
{% elseif include == 'ask-supervisor' -%}
	{% assign title = translations.AskGuardian -%}
	{% assign action = 'Contact/AskAboutProduct' -%}
	{% assign email = translations.Email -%}
	{% assign name = translations.CompanyName -%}
{% elseif include == 'recommend-product' -%}
	{% assign title = translations.RecommendProduct -%}
	{% assign action = 'Contact/TellFriendAboutProduct' -%}
	{% assign email = translations.Email -%}
{% endif -%}

<dialog class="dialog container-to-delete-js">
	<div class="popup rendered-dialog form-js need-product-id-js">
		<div class="popup__header title-js">
			<div class="title">{{ title }}</div>
			<button class="close-js">
				<svg class="close-button">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
				</svg>
			</button>
		</div>
		<div class="popup__content">
			<input type="hidden" name="__action" value="{{ action }}">
			<div class="form__product-name">{{ product.NameNoHtml }}</div>
			<div class="form__input-wrapper">
				<label for="email" data-type="email" class="form__input-info input-info-js"><span class='required'>* </span>{{ email }}</label>
				<input id="email" class="form__input-value input-value-js" type="email" name="email" value="{{ customer.Email }}" autocomplete="email" maxlength="192" required>  
				<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillEmail }}</div>
				<div class="form__invalid-input validation-info-js email-valid-js hidden-js">{{ translations.FillProperEmail }}</div>
			</div>
			{% unless include == 'ask-for-price' or include == 'recommend-product' -%}
				{% if customer.Company -%}
					<div class="form__input-wrapper">
						<label for="customer-name" data-type="text" class="form__input-info input-info-js">{% unless include == 'recommend-product' -%}<span class='required'>* </span>{% endunless -%}{{ name }}</label>
						<input id="customer-name" class="form__input-value input-value-js" type="text" name="name" value="{{ customer.Address.Name | H }}" maxlength="50" {% unless include == 'recommend-product' -%}required{% endunless -%}>
						<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillCompanyName }}</div>
					</div>
				{% else -%}
					<div class="form__input-wrapper">
						<label for="name" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.NameAndSurname }} </label>
						<input id="name" class="form__input-value input-value-js" type="text" name="name" value="{{ address.Name | H }}" maxlength="50" required {% if readonly -%} readonly {% endif -%} >
						<div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillNameAndSurname }}</div>
					</div>
				{% endif -%}
			{% endunless -%}
			{% if include == 'recommend-product' -%}
				<div class="form__input-wrapper">
					<label for="friendEmail" data-type="email" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.FriendEmail }}</label>
					<input id="friendEmail" class="form__input-value input-value-js" type="email" name="friendEmail" autocomplete="email" maxlength="192" required>  
					<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillEmail }}</div>
					<div class="form__invalid-input validation-info-js email-valid-js hidden-js">{{ translations.FillProperEmail }}</div>
				</div>
			{% endif -%}
			{% unless include == 'recommend-product' -%}
				<div class="form__input-wrapper">
					<label for="phoneNo" class="form__input-info input-info-js">{{ translations.PhoneNumber }}</label>
					<input id="phoneNo" class="form__input-value input-value-js" type="tel" name="phoneNo" value="{{ customer.PhoneNo }}" maxlength="20" >
				</div>
			{% endunless -%}
			{% if include == 'ask-for-price' -%}
				<div class="form__wrapper ask-for-price-quantity">
					<div class="form__input-wrapper">
						<label for="quantity" data-type="text" class="form__input-info input-info-js on-label">{{ translations.Quantity }}</label>
						<span class="quantity">
							<button class="quantity__minus change-quantity-js decrement-js" aria-label="{{ translations.DecreaseQuantity }}">
								<svg class="icon">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#minus-{{settings.iconStyle}}"></use>
								</svg>
							</button>
							<input id="quantity" class="quantity__input" aria-label="{{ translations.ChangeQuantity }}" type="text" name="quantity" value="1" data-min="1" data-max="99999">
							<button aria-label="{{ translations.IncreaseQuantity }}" class="quantity__plus change-quantity-js increment-js">
								<svg class="icon">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#plus-{{settings.iconStyle}}"></use>
								</svg>
							</button>
						</span>
						<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillQuantity }}</div>
						<div class="form__invalid-input validation-info-js validation-quantity-range-js hidden-js">{{ translations.FillProperQuantityRange }} 1 - 99999</div>
					</div>
					{% assign showBasicUnitInfo = false -%}
					{% if settings.showUnitRateOnProductDetailsPageUnit == 'basic' and product.BasicUnit != unitName -%}
						{% assign showBasicUnitInfo = true -%}
					{% endif -%}
					<span class="form__input-wrapper unit-container units-js" data-unit="{{unitId}}" data-unit-ratio-info="{{showBasicUnitInfo}}" data-basic-unit-ratio="{{product.BasicUnitRatio}}">
						{% if product.Units[1] -%}
							<div tabindex="0" class="unit-container__units select select-js">
								<select id="unit-select-{{ product.Id }}" class="memory-js" aria-label="{{ translations.Unit }}">
									{% for unit in product.Units -%}
										{% if unit.Id == unitId -%}
											{% assign defaultUnitName = unit.Name -%}
										{% endif -%}
										<option value="{{ unit.Name | H }}" {% if unit.Id == unitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
									{% endfor -%}
								</select>
								<div class="select__input">
									<span class="selected-js">
										{{ defaultUnitName | H }}
									</span>
									<svg>
										<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
									</svg>
								</div>
								<ul class="select__options options-js">
									{% for unit in product.Units -%}
										<li>{{ unit.Name | H }}</li>
									{% endfor -%}
								</ul>
							</div>
							<div class="unit-container__unit-ratio-info">
								{% if settings.showUnitRateOnProductDetailsPage == 'yes' -%}
									{% assign productUnitsSize = product.Units | Size -%}
									{% for unit in product.Units -%}
										{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
											{% if unit.Id != unitId -%}
												<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | DividedBy: product.BasicUnitRatio | Round: 4 }} {{ product.SaleUnit }}</span>
											{% endif -%}
										{% else -%}
											{% if unit.Name != product.BasicUnit -%}
												<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{unit.Ratio | Round: 4}} {{product.BasicUnit}}</span>
											{% endif -%}
										{% endif -%}
									{% endfor -%}
								{% endif -%}
							</div>
						{% else -%}
							{{ product.SaleUnit }}
						{% endif -%}
					</span>
				</div>
			{% endif -%}
			{% unless include == 'notify-about-availability' -%}
				<div class="form__input-wrapper textarea">
					{% assign maxLength = 500 -%}
					<label for="message-textarea" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.MessageContent }}</label>
					<div class="scrollable"></div>
					<textarea id="message-textarea" class="form__input-value input-value-js" aria-label="message" maxlength="500" name="message" required></textarea>
					<div class="characters-counter characters-counter-js"></div>
					<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillMessageContent }}</div>
				</div>
			{% endunless -%}
			<div class="required-fields"><span class="required">*</span> {{ translations.RequiredFields }}</div>
			{% if include == 'ask-supervisor' -%}
				{% if product-presentation.Product.Supervisor -%}
					{% if settings.showProductGuardian == 'only-authenticated' and customer.Authenticated -%}
						{% assign showProductGuardian = true -%}
					{% endif -%}
					{% if settings.showProductGuardian == 'yes' or showProductGuardian -%}
						{% assign showProductGuardianFinal = true -%}
					{% endif -%}
					{% if showProductGuardianFinal -%}
						{% assign supervisor = product-presentation.Product.Supervisor -%}
						<div class="supervisor supervisor-js">
							<div class="supervisor__img">
								{% if supervisor.ImageUrl == null -%}
									<svg {% if settings.showGuardianNameAs != 'nothing' -%} title="{{supervisor.FirstName}} {% if settings.showGuardianNameAs == 'name-and-surname' -%}{{supervisor.LastName}}{% endif -%}" {% endif -%}>
										<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
									</svg>
								{% else -%}
									<img src="css/img/alo.gif" data-src="{{supervisor.ImageUrl}}" {% if settings.showGuardianNameAs != 'nothing' -%} title="{{supervisor.FirstName}} {% if settings.showGuardianNameAs == 'name-and-surname' -%}{{supervisor.LastName}}{% endif -%}" {% endif -%}>
								{% endif -%}
							</div>
							<div class="supervisor__info">
								<div class="supervisor__info-details">
									{% if settings.showGuardianNameAs != 'nothing' -%}{{ translations.YourSupervisor }}:<span>{{supervisor.FirstName}} {% if settings.showGuardianNameAs == 'name-and-surname' -%}{{supervisor.LastName}}{% endif -%}{% endif -%}</span>
								</div>
								<div class="supervisor__info-details">
									<svg height="24" width="24">
										<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{settings.iconStyle}}"></use>
									</svg>
									<a class="phone" href="mailto:{{ supervisor.Email }}">{{ supervisor.Email }}</a>
								</div>
								{% if settings.showGuardianPhoneNo == 'yes' and supervisor.PhoneNo != '' -%}
									{% assign showSupervisorPhone = true -%}
								{% endif -%}
								{% if settings.showGuardianPhoneNo == 'main-phone' and config.Shop.Contact.PhoneNo != '' -%}
									{% assign showMainPhone = true -%}
								{% endif -%}
								{% if showSupervisorPhone or showMainPhone -%}
									<div class="supervisor__info-details">
										<svg height="24" width="24" class="contact-info__icon">
											<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#headset-{{settings.iconStyle}}"></use>
										</svg>
										{% if showSupervisorPhone -%}
											<a class="phone" href="tel:{{supervisor.PhoneNo}}">{{supervisor.PhoneNo}}</a>
										{% else -%}
											<a class="phone" href="tel:{{config.Shop.Contact.PhoneNo}}">{{config.Shop.Contact.PhoneNo}}</a>
										{% endif -%}
									</div>
								{% endif -%}
							</div>
						</div>
						<div class="supervisor__info-description">
							{{ translations.SupervisorDescription }}
						</div>
					{% endif -%}
				{% endif -%}
			{% endif -%}
		</div>
		<div class="popup__buttons">
			<button aria-label="post-and-delete-title" class="primary-action-button post-js close-js" {% if include == 'ask-supervisor' or include == 'ask-for-product' -%} style="width: 100%;" {% endif -%} {% if include == 'notify-about-availability' -%}data-value="{{product.Price}}"{% endif -%}>
				<span class="primary-action-button__text" style="pointer-events: none;">{{ translations.Send }}</span>
				<svg width="20" height="20" style="pointer-events: none;">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{ settings.iconStyle }}"></use>
				</svg>
			</button>
		</div>
	</div>
</dialog>
`